import { useState } from 'react';
import { Modal } from 'antd';
import { toE164 } from '../../utils/callLog';
import { Field, FieldLabel, Form, FormField, TextArea } from '../../components';

export default function NewMessageModal({ onClose, onStart, sending }) {
  const [number, setNumber] = useState('');
  const [body, setBody] = useState('');
  const e164 = toE164(number);

  return (
    <Modal
      title="New message"
      open
      onCancel={onClose}
      onOk={() => onStart(e164, body.trim())}
      okText={body.trim() ? 'Send message' : 'Open conversation'}
      confirmLoading={sending}
      okButtonProps={{ disabled: !e164 }}
    >
      <Form>
        <FormField>
          <FieldLabel htmlFor="new-msg-number">Recipient phone</FieldLabel>
          <Field
            id="new-msg-number"
            type="tel"
            autoComplete="tel"
            placeholder="(555) 555-0100"
            value={number}
            aria-invalid={Boolean(number) && !e164}
            onChange={(e) => setNumber(e.target.value)}
          />
        </FormField>
        <FormField>
          <FieldLabel htmlFor="new-msg-body">First message (optional)</FieldLabel>
          <TextArea
            id="new-msg-body"
            placeholder="Type a message…"
            maxLength={1600}
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
        </FormField>
      </Form>
    </Modal>
  );
}
